import React, { useState } from 'react';
import { Eye, Pencil, Power, Trash2 } from 'lucide-react';
import {
  ActionMenuDivider,
  ActionMenuItem,
  ActionsDropdownMenu,
} from '../deep-links/ActionsDropdownMenu';
import { MembershipPlan } from '../../../services/MasterAdmin/membershipService';

interface MembershipPlanActionsMenuProps {
  plan: MembershipPlan;
  onView: (plan: MembershipPlan) => void;
  onEdit: (plan: MembershipPlan) => void;
  onToggleActive: (plan: MembershipPlan) => void;
  onDelete: (plan: MembershipPlan) => void;
}

const MembershipPlanActionsMenu: React.FC<MembershipPlanActionsMenuProps> = ({
  plan,
  onView,
  onEdit,
  onToggleActive,
  onDelete,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <ActionsDropdownMenu open={open} onToggle={() => setOpen((v) => !v)} onClose={() => setOpen(false)}>
      <ActionMenuItem
        icon={<Eye className="h-4 w-4 text-blue-600 dark:text-blue-400" />}
        label="View"
        onClick={() => { setOpen(false); onView(plan); }}
      />
      <ActionMenuItem
        icon={<Pencil className="h-4 w-4 text-amber-600 dark:text-amber-400" />}
        label="Edit"
        onClick={() => { setOpen(false); onEdit(plan); }}
      />
      <ActionMenuDivider />
      <ActionMenuItem
        icon={<Power className={`h-4 w-4 ${plan.isActive ? 'text-gray-500 dark:text-gray-400' : 'text-emerald-600'}`} />}
        label={plan.isActive ? 'Deactivate' : 'Activate'}
        onClick={() => { setOpen(false); onToggleActive(plan); }}
      />
      <ActionMenuDivider />
      <ActionMenuItem
        icon={<Trash2 className="h-4 w-4 text-red-500" />}
        label="Delete plan"
        onClick={() => { setOpen(false); onDelete(plan); }}
      />
    </ActionsDropdownMenu>
  );
};

export default MembershipPlanActionsMenu;
